import React from 'react';
import StyledText from './StyledText';

interface TextProps {
  children: React.ReactNode;
  lineHeight?: number | string;
  letterSpacing?: number | string;
  type:
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'subtitle1'
    | 'subtitle2'
    | 'body1'
    | 'body2'
    | 'label';
  width?: string;
  bold?: boolean;
  [key: string]: any; // For any additional props (like color, align, etc.)
}

const Text: React.FC<TextProps> = ({
  children,
  lineHeight = 1.75,
  letterSpacing = '0.00938em',
  type,
  width = 'revert',
  bold,
  ...props
}) => {
  if (type === 'label') {
    return (
      <label style={bold ? { fontWeight: 700 } : undefined}>{children}</label>
    );
  }

  return (
    <StyledText
      lineHeight={lineHeight}
      letterSpacing={letterSpacing}
      variant={type}
      width={width}
      bold={bold}
      {...props}
    >
      {children}
    </StyledText>
  );
};

export default Text;
